<template>
  <div class="searchBox">
    <el-form
      ref="searchForm" v-model="queryForm" :inline="false"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item size="small">
            <el-select
              v-model="queryForm.params.searchNumberType"
              :placeholder="$t('orderDetails.pleaseChoose')"
              :style="IsWidth"
              class="selectClass"
              size="small"
              @change="handleChangeLable"
            >
              <!--运单号-->
              <el-option key="1" :label="$t('orderCenterCont.anjunWaybillNumber')" value="1" />
              <!--扫描单号-->
              <el-option key="8" :label="$t('GlobalSetObj.ScanNumber')" value="8" />
              <!--服务商物流单号-->
              <el-option key="5" :label="$t('GlobalSetObj.serviceLogistics')" value="5" />
              <!-- 安骏订单号 -->
              <el-option key="15" :label="$t('GlobalSetObj.anJunOrderNumber')" value="15" />
              <!--客户订单号-->
              <el-option key="2" :label="$t('newOrder.PlatformOrderNumber')" value="2" />
              <!--揽收袋号-->
              <el-option key="3" :label="$t('orderCenterCont.PickUpBagNumber')" value="3" />
              <!--中转仓袋号-->
              <el-option key="4" :label="$t('orderCenterCont.TransitBinBagNumber')" value="4" />
              <!--子包号-->
              <el-option key="7" :label="$t('orderCenterCont.SubpackageNumber')" value="7" />
              <!-- CTE发票号 -->
              <el-option key="17" :label="$t('driver.cteInvoiceNumber')" value="17" />
              <!--NFE发票号-->
              <el-option key="10" :label="'NFE' + $t('newOrder.InvoiceNumber')" value="10" />
              <!--发票密钥-->
              <el-option key="9" :label="'NFE' + $t('newOrder.InvoiceKey')" value="9" />
              <!-- 收件人CPF -->
              <el-option key="16" :label="$t('driver.recipientCPF')" value="16" />
            </el-select>
            <el-input
              v-model="searchNumberStr"
              :placeholder="$t('newOrder.PreciseSearch1')"
              :rows="1"
              style="margin-top: 3px"
              type="textarea"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!--创建时间-->
          <el-form-item prop="searchTimeType" size="small">
            <el-select
              v-model="queryForm.params.searchTimeType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :style="IsWidthTime"
              class="selectClass"
              @change="SwitchTimeType"
            >
              <!--创建时间-->
              <el-option key="1" :label="$t('newOrder.createTime')" value="1" />
              <!--客户出仓时间-->
              <el-option key="5" :label="$t('orderCenterCont.customerDeliveryTime')" value="5" />
              <!--转运入库时间-->
              <el-option key="3" :label="$t('newOrder.TransitInboundTime')" value="3" />
              <!--转运出库时间-->
              <el-option key="4" :label="$t('newOrder.shipmentTime')" value="4" />
              <!--网点入库时间-->
              <!--                <el-option key="6" :label="$t('newOrder.StorageTimeOutlets')" value="6" />-->
              <!--                网点派件时间-->
              <el-option key="7" :label="$t('orderCenterCont.deliveryTime')" value="7" />
              <!--签收时间-->
              <el-option key="2" :label="$t('orderCenterCont.SigningTime')" value="2" />
            </el-select>
            <el-date-picker
              v-model="timeValue"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('operationCenter.endDate')"
              :format="$i18n.locale === 'zh' ? zhDate : ptDate"
              :picker-options="pickerOptions"
              :start-placeholder="$t('operationCenter.startDate')"
              range-separator="~"
              size="small"
              style="width: 100%; margin-top: 3px"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleTime"
              @input="changeInput($event)"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--运单状态-->
          <el-form-item :label="$t('newOrder.waybillStatus')" class="label_class">
            <el-select
              v-model="queryForm.params.waybillStatus"
              :placeholder="$t('GlobalSetObj.all')"
              clearable
              collapse-tags
              filterable
              multiple
              size="small"
              style="width: 100%"
              @change="selectStatus"
            >
              <el-option
                v-for="(item, ind) in waybillStatusList"
                :key="ind"
                :label="item.label"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--客户-->
          <el-form-item name="customerIds">
            <el-select
              v-model="customerType"
              :placeholder="$t('orderDetails.pleaseChoose')"
              class="selectClass label33"
              size="small"
              @change="handleChangeCustomerType"
            >
              <!--客户名称-->
              <el-option :label="$t('newOrder.CustomerName')" :value="1" />
              <!--客户渠道-->
              <el-option :label="$t('customerManagements.customerChannel')" :value="2" />
            </el-select>
            <el-select
              v-if="customerType === 1"
              :key="'customerNameSelect'"
              v-model="queryForm.params.customerIds"
              :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              multiple
              remote
              reserve-keyword
              size="small"
              style="width: 100%"
              @clear="getCustomerPage('')"
              @focus="getCustomerPageFuc"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerAlias + '(' + item.username + ')'"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-if="customerType === 2"
              :key="'customerChannelSelect'"
              v-model="queryForm.params.customerChannelList"
              :placeholder="$t('orderDetails.pleaseChoose')"
              multiple
              clearable
              filterable
              style="width: 100%"
              @visible-change="getChannelData"
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="index"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div style="margin-top: 32px">
            <!--搜索-->
            <el-button size="small" type="primary" @click="getData(1)">{{ $t('newOrder.search') }}
            </el-button>
            <!--高级搜索-->
            <el-button size="small" type="primary" @click="advancedSearch">{{ $t('home.advancedSearch') }}
            </el-button>
            <!--清空当前内容-->
            <el-button
              size="small" style="margin-left: 10px" type="info"
              @click="resetForm"
            >
              {{ $t('customerManagements.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 已选条件（仅展示高级搜索内的条件） -->
    <div v-if="getSelectedConditions().length" class="selected-conditions">
      <span class="selected-label">
        <i class="el-icon-filter" />
        {{ $t('seller.selectedConditions') }}:
      </span>
      <el-tag
        v-for="item in getSelectedConditions()"
        :key="item.key"
        class="selected-tag"
        closable
        size="medium"
        @close="removeCondition(item.key)"
      >
        {{ item.label }}: {{ item.value }}
      </el-tag>
      <el-button class="clear-all-btn" type="text" @click="clearAllConditions">
        <i class="el-icon-delete" />
        {{ $t('seller.clearAll') }}
      </el-button>
    </div>
    <el-drawer
      :append-to-body="true"
      :title="$t('home.advancedSearch')"
      :visible.sync="searchDrawer"
      direction="ltr"
      size="600px"
      @closed="handleClosed"
    >
      <el-form label-position="top" size="small">
        <el-row
          :gutter="10"
          justify="left"
          style="flex-wrap: wrap; padding: 0 20px; box-sizing: border-box"
          type="flex"
        >
          <el-col :span="12">
            <!--货物类型-->
            <el-form-item :label="$t('placeOrder.cargoType')" size="small">
              <el-select v-model="queryForm.params.cargoType" style="width: 100%">
                <el-option :label="$t('GlobalSetObj.all')" value="" />
                <el-option :label="$t('placeOrder.normal01')" :value="0" />
                <el-option :label="$t('GlobalSetObj.big01')" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--包裹类型-->
            <el-form-item :label="$t('placeOrder.packageType')" size="small">
              <el-select v-model="queryForm.params.orderPackageType" style="width: 100%">
                <el-option :label="$t('GlobalSetObj.all')" :value="0" />
                <el-option
                  v-for="(item, index) in ParcelType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('collectionCenter.tipoTitle')" size="small">
              <el-select
                v-model="queryForm.params.isReverse"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                style="width: 100%"
              >
                <el-option :label="$t('collectionCenter.tudo')" :value="null" /><!-- 全部 -->
                <el-option :label="$t('collectionCenter.originalOrder')" :value="0" /><!-- 原单 -->
                <el-option
                  :label="$t('collectionCenter.originalOrderReturned')"
                  :value="2"
                /><!-- 原单退回 -->
                <el-option
                  :label="$t('collectionCenter.newOrderReturned')"
                  :value="1"
                /><!-- 新单退回 -->
                <el-option
                  :label="$t('trajectory.originalOrderReturn_D2D')"
                  :value="3"
                /><!-- 原单退回D2D -->
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--商户号-->
            <el-form-item :label="$t('collectionCenter.merchantCode')" size="small">
              <el-input
                v-model.trim="queryForm.params.merchantCode"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--商户名称-->
            <el-form-item :label="$t('collectionCenter.MerchantName')" size="small">
              <el-select
                v-model="queryForm.params.merchantCodeList"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getMerchantList"
                clearable
                collapse-tags
                filterable
                multiple
                remote
                reserve-keyword
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in merchantList"
                  :key="index"
                  :label="`${item.merchantName} - ${item.merchantCode}`"
                  :value="item.merchantCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--实际揽收网点-->
            <el-form-item :label="$t('newOrder.ActualCollection')" size="small">
              <el-select
                v-model="queryForm.params.collectStationId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="remoteGetSiteList"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                @focus="remoteGetSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="label28_class">
            <!--实际派送网点-->
            <el-form-item>
              <el-select
                v-model="queryForm.params.deliverWarehouseStationType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                class="selectClass label28"
                size="small"
              >
                <el-option :label="$t('GlobalSetObj.entrega')" value="1" />
                <el-option :label="$t('GlobalSetObj.infeatSite')" value="2" />
              </el-select>
              <el-select
                v-model="queryForm.params.deliverStationId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="remoteGetSiteList"
                clearable
                filterable
                remote
                reserve-keyword
                size="small"
                style="width: 100%"
                @focus="remoteGetSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--预派送网点-->
            <el-form-item :label="$t('GlobalSetObj.preEntrega')" size="small">
              <el-select
                v-model="queryForm.params.preDeliverStationId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                :remote-method="remoteGetSiteList"
                clearable
                filterable
                remote
                reserve-keyword
                style="width: 100%"
                @focus="remoteGetSiteList('')"
              >
                <el-option
                  v-for="item in siteList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--派送员-->
            <el-form-item :label="$t('orderCenterCont.deliveryPerson')" size="small">
              <el-select
                v-model="queryForm.params.deliveryManName"
                :placeholder="$t('GlobalSetObj.OnlyAreDisplayed')"
                :remote-method="getallDriver"
                clearable
                filterable
                remote
                style="width: 100%"
                @focus="getallDriver('')"
              >
                <el-option
                  v-for="item in drvierList"
                  :key="item.id"
                  :label="item.username"
                  :value="item.username"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--收件人邮编-->
            <el-form-item :label="$t('receivablePayable.RecipientzipCode')" size="small">
              <el-input
                v-model.trim="queryForm.params.receiveZipcode"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--收件人名字-->
            <el-form-item :label="$t('receivablePayable.receiveName')" size="small">
              <el-input
                v-model.trim="queryForm.params.receiveName"
                :placeholder="$t('orderDetails.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!--收件人州-->
            <el-form-item :label="$t('newOrder.RecipientState')" size="small">
              <el-select
                v-model="queryForm.params.receiveStateList"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="drawer-footer">
        <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
        <el-button size="small" type="primary" @click="handleSearch">{{
          $t('newOrder.search')
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { providerchannelall } from '@/api/logisticsOrders';
import { apiCustomerPage, apimerchantName, getCustomerChannelList } from '@/api/customer';
import dayjs from 'dayjs';
import { waybillStatusList } from '@/utils/enumData';
import { siteFuzzyQuery } from '@/api/lanshou';
import { getLgAreaListData } from '@/api/orderApi';
import { signRescissiongetPmUserList } from '@/api/resources';
import { ParcelType } from '@/views/orderCenter/logisticsOrders/utils';

export default {
  name: 'Search',
  props: {
    pagination: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      searchDrawer: false,
      channelList: [],
      customerType: 1,
      queryForm: {
        pageSize: 10,
        number: 1,
        params: {
          searchTimeType: '1',
          waybillStatus: [],
          createStartTime: '',
          createEndTime: '',
          waybillNumber: '',
          searchNumberType: '1',
          deliverWarehouseStationType: '1',
          // providerChannelIdList: [],
          customerIds: [],
          customerChannelList: [],
          deliverStationId: '',
          collectStationId: '', // 实际揽收网点
          preDeliverStationId: '', // 预派送网点
          orderPackageType: 0,
          cargoType: '',
          merchantCode: '',
          merchantCodeList: [],
          deliveryManName: '', // 派件人
          accountType: 0,
          receiveStateList: [],
          receiveName: '',
          receiveZipcode: '',
          isReverse: null
        }
      },
      searchNumberStr: '',
      searchNumberList: [],
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      // 是否格式化成巴西时间
      isTormat: false,
      // 查询列表数据
      selectLabel: [
        { id: 1, label: this.$t('newOrder.waybillNumber'), value: 1 },
        { id: 2, label: this.$t('newOrder.PlatformOrderNumber'), value: 2 },
        // { id: 3, label: this.$t('orderCenterCont.PickUpBagNumber'), value: 3 },
        { id: 4, label: this.$t('orderCenterCont.TransitBinBagNumber'), value: 4 },
        { id: 5, label: this.$t('GlobalSetObj.serviceLogistics'), value: 5 },
        // { id: 6, label: this.$t('newOrder.InvoiceNumber'), value: 6 },
        { id: 7, label: this.$t('orderCenterCont.SubpackageNumber'), value: 7 }
      ],
      searchNameObj: { id: 1, label: this.$t('newOrder.waybillNumber'), value: 1 },
      channelall: [],
      customerList: [], // 客户列表
      timeValue: [],
      drvierList: [], // 派件员
      siteList: [], // 网点列表
      selectDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      waybillStatusList: waybillStatusList,
      StateList: [],
      merchantList: [],
      siteNameMap: {}, // 网点 id -> 名称（已选条件展示用）
      searMerchantName: ''
    };
  },
  computed: {
    ParcelType() {
      return ParcelType;
    },
    IsWidth() {
      return {
        width: this.isTormat ? '250px' : '130px'
      };
    },
    IsWidthTime() {
      return {
        width: this.isTormat ? '200px' : '150px'
      };
    }
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        console.log(1);
        this.queryForm.pageSize = newVal.pageSize;
        this.queryForm.pageNumber = newVal.pageNumber;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getallDriver();
    // 获取网点前十页
    this.remoteGetSiteList();
    this.getTimer();
    this.getAddress();
    this.getAllProviderChannel();
    this.getChannel();
  },
  methods: {
    handleClosed() {
      this.searchDrawer = false;
    },
    advancedSearch() {
      this.searchDrawer = true;
    },
    handleReset() {
      this.queryForm.params.cargoType = '';
      this.queryForm.params.orderPackageType = 0;
      this.queryForm.params.isReverse = null;
      this.queryForm.params.merchantCode = '';
      this.queryForm.params.merchantCodeList = [];
      this.queryForm.params.collectStationId = '';
      this.queryForm.params.deliverWarehouseStationType = '1';
      this.queryForm.params.deliverStationId = '';
      this.queryForm.params.preDeliverStationId = '';
      this.queryForm.params.deliveryManName = '';
      this.queryForm.params.receiveZipcode = '';
      this.queryForm.params.receiveName = '';
      this.queryForm.params.receiveStateList = [];
      this.searMerchantName = '';
      this.merchantList = [];
    },
    handleSearch() {
      this.searchDrawer = false;
      this.getData(1);
    },
    handleChangeCustomerType() {
      this.queryForm.params.customerIds = [];
      this.queryForm.params.customerChannel = '';
    },
    getChannelData() {
      if (this.channelList.length <= 0) {
        this.getChannel();
      }
    },
    getChannel() {
      getCustomerChannelList().then((res) => {
        if (res.code === 200) {
          this.channelList = res.data || [];
        }
      });
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.searchNumberStr = '';
      this.searMerchantName = '';
      this.queryForm.params = {
        searchTimeType: '1',
        waybillStatus: [],
        createStartTime: '',
        createEndTime: '',
        waybillNumber: '',
        searchNumberType: '1',
        deliverWarehouseStationType: '1',
        // providerChannelIdList: [],
        customerIds: [],
        customerChannel: '',
        deliverStationId: '',
        collectStationId: '', // 实际揽收网点
        preDeliverStationId: '', // 预派送网点
        orderPackageType: 0,
        cargoType: '',
        merchantCode: '',
        merchantCodeList: [],
        deliveryManName: '', // 派件人
        accountType: 0,
        receiveStateList: [],
        receiveName: '',
        receiveZipcode: '',
        isReverse: null
      };
      this.getTimer();
      this.getData(10);
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      // const oneWeekAgo = dayjs(brazilTime).subtract(1, 'week').format('YYYY-MM-DD');
      this.timeValue = [today + ' 00:00:00', today + ' 23:59:59'];
      this.queryForm.params.createStartTime = this.timeValue[0];
      this.queryForm.params.createEndTime = this.timeValue[1];
    },
    changeInput(val) {
      this.$emit('input', val);
    },
    // 修改时间
    handleTime(val) {
      if (val) {
        const startDate = dayjs(val[0]);
        const endDate = dayjs(val[1]);
        // 计算天数差（取绝对值，确保顺序不影响结果）
        const daysDiff = Math.abs(endDate.diff(startDate, 'day'));
        // 判断是否超过31天
        const isOver31Days = daysDiff > 31;
        if (isOver31Days) {
          this.$message.error(this.$t('tablePrice.timeRangeLimit'));
          this.getTimer();
        } else {
          this.queryForm.params.createStartTime = val[0];
          this.queryForm.params.createEndTime = val[1];
        }
      } else {
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      // this.$emit('searchFun', this.queryForm, this.searchNumberList);
    },
    // 获取所有渠道
    getAllProviderChannel() {
      this.channelall = [];
      providerchannelall().then((res) => {
        if (res.code === 200) {
          console.log('获取所有渠道', res.data);
          this.channelall = res.data;
        }
      });
    },
    // 获取派送员
    getallDriver(name) {
      const data = {
        operateUserName: name
      };
      signRescissiongetPmUserList(data).then((res) => {
        if (res.code === 200) {
          console.log('获取派送员', res.data);
          this.drvierList = res.data;
        }
      });
    },
    /**
     * @description 分页查询网点列表
     * @param val
     */
    remoteGetSiteList(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.code === 200) {
          this.siteList = res.data
          // 缓存网点名称，避免远程搜索覆盖列表后已选条件展示成 id
          ;(res.data || []).forEach((item) => {
            this.$set(this.siteNameMap, item.id, item.name);
          });
        }
      });
    },
    // 切换时间
    SwitchTimeType(val) {
      this.queryForm.params.searchTimeType = val;
    },
    handleChangeLable(val) {
      const index = val - 1;
      this.searchNameObj = this.selectLabel[index];
    },
    selectStatus(val) {
      console.log(val, 'valvalselectStatus');
      console.log(val.indexOf(0), 'STATUS');
      if (val.indexOf(0) !== -1) {
        this.queryForm.params.waybillStatus = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22
        ];
      }
      // if (val.includes(3)) {
      //   val.push(19);
      // }
    },
    // 查询单号整理
    searchNumberCollation() {
      if (this.searchNumberStr) {
        // 单号格式化，去除空格
        const orderNumber = this.searchNumberStr.split(/[(\r\n)\r\n]+/);
        const numberList = [];
        orderNumber.map((item) => {
          if (item) {
            numberList.push(item.trim());
          }
        });
        this.searchNumberList = numberList;
      } else {
        this.searchNumberList = [];
      }
    },
    // 回车查询
    searchFun() {
      this.searchNumberCollation();
      this.queryForm.number = this.pagination.number;
      this.queryForm.pageSize = this.pagination.pageSize;
      if (this.searchNumberList.length > 0) {
        this.timeValue = [];
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      this.$emit('searchFun', this.queryForm, this.searchNumberList);
    },
    // 搜索组件点击搜索按钮事件
    getData(type) {
      this.searchNumberCollation();
      this.queryForm.number = this.pagination.number;
      this.queryForm.pageSize = this.pagination.pageSize;
      if (this.searchNumberList.length > 0) {
        this.timeValue = [];
        this.queryForm.params.createStartTime = '';
        this.queryForm.params.createEndTime = '';
      }
      this.$emit('searchFun', this.queryForm, this.searchNumberList, type);
    },
    /**
     * @description 分页获取客户列表
     * @param { string } name 客户名称
     */
    getCustomerPage(name) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: name
        }
      };
      apiCustomerPage(param).then((res) => {
        if (res.code === 200) {
          this.customerList = res.data.records;
        }
      });
    },
    getCustomerPageFuc() {
      if (this.customerList.length === 0) {
        this.getCustomerPage('');
      }
    },
    // 获取商户列表
    getMerchantList(val = '', flag) {
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: ''
        }
      };
      if (flag) {
        if (this.merchantList.length === 0) {
          apimerchantName(data).then((res) => {
            if (res.code === 200) {
              this.merchantList = res.data.records;
            }
          });
        }
      } else {
        data.params.merchantName = val;
        apimerchantName(data).then((res) => {
          if (res.code === 200) {
            this.merchantList = res.data.records;
          }
        });
      }
    },
    // 州
    getAddress() {
      // level 0 州    1 城市   2 地区
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 根据网点 id 获取名称
    getSiteNameById(id) {
      return this.siteNameMap[id] || id;
    },
    // 已选条件展示数据（仅展示高级搜索抽屉内的条件）
    getSelectedConditions() {
      const list = [];
      const p = this.queryForm.params;

      // 货物类型
      if (p.cargoType === 0 || p.cargoType === 1) {
        list.push({
          key: 'cargoType',
          label: this.$t('placeOrder.cargoType'),
          value: p.cargoType === 0 ? this.$t('placeOrder.normal01') : this.$t('GlobalSetObj.big01')
        });
      }

      // 包裹类型（0 为全部，不展示）
      if (p.orderPackageType && p.orderPackageType !== 0) {
        const map = {
          1: this.$t('placeOrder.zhifa'),
          2: this.$t('orderCenterCont.hedan'),
          5: this.$t('mdfeTranslate.multipleItemsPerOrderSingleNfe'),
          6: this.$t('mdfeTranslate.multipleItemsPerOrderMultiNfe'),
          4: this.$t('GlobalSetObj.big01'),
          3: this.$t('orderCenterCont.other')
        };
        list.push({
          key: 'orderPackageType',
          label: this.$t('placeOrder.packageType'),
          value: map[p.orderPackageType] || p.orderPackageType
        });
      }

      // 订单类型
      if (p.isReverse !== null && p.isReverse !== undefined) {
        const map = {
          0: this.$t('collectionCenter.originalOrder'),
          2: this.$t('collectionCenter.originalOrderReturned'),
          1: this.$t('collectionCenter.newOrderReturned'),
          3: this.$t('trajectory.originalOrderReturn_D2D')
        };
        list.push({
          key: 'isReverse',
          label: this.$t('collectionCenter.tipoTitle'),
          value: map[p.isReverse] !== undefined ? map[p.isReverse] : p.isReverse
        });
      }

      // 商户号
      if (p.merchantCode) {
        list.push({
          key: 'merchantCode',
          label: this.$t('collectionCenter.merchantCode'),
          value: p.merchantCode
        });
      }

      // 商户名称
      if (p.merchantCodeList && p.merchantCodeList.length) {
        const names = p.merchantCodeList.map((code) => {
          const m = this.merchantList.find((item) => item.merchantCode === code);
          return m ? `${m.merchantName} - ${m.merchantCode}` : code;
        });
        list.push({
          key: 'merchantCodeList',
          label: this.$t('collectionCenter.MerchantName'),
          value: names.join(', ')
        });
      }

      // 实际揽收网点
      if (p.collectStationId) {
        list.push({
          key: 'collectStationId',
          label: this.$t('newOrder.ActualCollection'),
          value: this.getSiteNameById(p.collectStationId)
        });
      }

      // 实际派送网点 / 实际入库网点
      if (p.deliverStationId) {
        const isWarehouse = p.deliverWarehouseStationType === '2';
        list.push({
          key: 'deliverStationId',
          label: this.$t(isWarehouse ? 'GlobalSetObj.infeatSite' : 'GlobalSetObj.entrega'),
          value: this.getSiteNameById(p.deliverStationId)
        });
      }

      // 预派送网点
      if (p.preDeliverStationId) {
        list.push({
          key: 'preDeliverStationId',
          label: this.$t('GlobalSetObj.preEntrega'),
          value: this.getSiteNameById(p.preDeliverStationId)
        });
      }

      // 派送员
      if (p.deliveryManName) {
        list.push({
          key: 'deliveryManName',
          label: this.$t('orderCenterCont.deliveryPerson'),
          value: p.deliveryManName
        });
      }

      // 收件人邮编
      if (p.receiveZipcode) {
        list.push({
          key: 'receiveZipcode',
          label: this.$t('receivablePayable.RecipientzipCode'),
          value: p.receiveZipcode
        });
      }

      // 收件人名字
      if (p.receiveName) {
        list.push({
          key: 'receiveName',
          label: this.$t('receivablePayable.receiveName'),
          value: p.receiveName
        });
      }

      // 收件人州
      if (p.receiveStateList && p.receiveStateList.length) {
        list.push({
          key: 'receiveStateList',
          label: this.$t('newOrder.RecipientState'),
          value: p.receiveStateList.join(', ')
        });
      }

      return list;
    },
    // 移除单个已选条件
    removeCondition(key) {
      const p = this.queryForm.params;
      switch (key) {
        case 'cargoType':
          p.cargoType = '';
          break;
        case 'orderPackageType':
          p.orderPackageType = 0;
          break;
        case 'isReverse':
          p.isReverse = null;
          break;
        case 'merchantCode':
          p.merchantCode = '';
          break;
        case 'merchantCodeList':
          p.merchantCodeList = [];
          break;
        case 'collectStationId':
          p.collectStationId = '';
          break;
        case 'deliverStationId':
          p.deliverWarehouseStationType = '1';
          p.deliverStationId = '';
          break;
        case 'preDeliverStationId':
          p.preDeliverStationId = '';
          break;
        case 'deliveryManName':
          p.deliveryManName = '';
          break;
        case 'receiveZipcode':
          p.receiveZipcode = '';
          break;
        case 'receiveName':
          p.receiveName = '';
          break;
        case 'receiveStateList':
          p.receiveStateList = [];
          break;
        default:
          break;
      }
      this.getData(1);
    },
    // 清空全部已选条件（仅清空高级搜索内的条件）
    clearAllConditions() {
      this.handleReset();
      this.getData(1);
    }
  }
};
</script>

<style scoped>
.searchBox .selectClass >>> .el-input__inner {
  border: none !important;
  color: #4e5969;
  font-size: 14px;
}

.searchBox >>> .el-form-item__content {
  line-height: 28px !important;
}

.selectClass.label33 >>> .el-input {
  height: 33px !important;
}

.label28_class >>> .el-form-item__content {
  line-height: 28px !important;
}

.selectClass.label28 >>> .el-input .el-input__inner {
  border: none !important;
}

.selectClass >>> .el-input {
  height: 28px !important;
}

.label_class >>> .el-form-item__label {
  line-height: 33px !important;
}

.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px;
}

.selected-conditions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  clear: both;
  width: 100%;
  padding: 5px 0;
  gap: 8px;
  margin-top: -10px;
}

.selected-conditions .selected-label {
  font-weight: bold;
  color: #303133;
  margin-right: 4px;
}

.selected-conditions .selected-tag {
  background: #f4f4f5;
  border-color: #e9e9eb;
  color: #606266;
}

.selected-conditions .clear-all-btn {
  margin-left: auto;
  color: #67c23a;
}

.selected-conditions .clear-all-btn:hover {
  color: #85ce61;
}
</style>
